<template>
  <svg
    id="flag-icon-css-de"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    :height="height"
  >
    <g fill-rule="evenodd">
      <path fill="#fff" d="M0 0h640v240H0z" />
      <path fill="#dc143c" d="M0 240h640v240H0z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PlFlag',
  props: {
    height: {
      type: String,
      default: '20px'
    }
  }
}
</script>
